import api from "../../utils/axiosInstance.js";

export const GET_TRADE_PAIR_REQUEST = "GET_TRADE_PAIR_REQUEST";
export const GET_TRADE_PAIR_SUCCESS = "GET_TRADE_PAIR_SUCCESS";
export const GET_TRADE_PAIR_ERROR = "GET_TRADE_PAIR_ERROR";
export const UPDATE_ALL_TRADE_PAIR_DATA = "UPDATE_ALL_TRADE_PAIR_DATA";
export const REMOVE_ALL_TRADE_PAIR = "REMOVE_ALL_TRADE_PAIR";

export const getAllTradePairList = (payloadData) => async (dispatch) => {
    dispatch({ type: GET_TRADE_PAIR_REQUEST });
    try {
        const res = await api.post("/pair/get-pairs", payloadData);
        if (res.data.success) {
            dispatch({ type: GET_TRADE_PAIR_SUCCESS, payload: res.data.result });
        } else {
            dispatch({ type: GET_TRADE_PAIR_ERROR, payload: res.data.message });
        }
    } catch (err) {
        dispatch({ type: GET_TRADE_PAIR_ERROR, payload: err.message });
    }
};

export const updateTradePairData = (newData) => ({ type: UPDATE_ALL_TRADE_PAIR_DATA, payload: newData });

export const removeTradePairData = (newData) => ({ type: REMOVE_ALL_TRADE_PAIR, payload: newData });
